import {
    adminSftpTestFileDownload,
    adminSftpTestFiles,
} from "@/shared/api/userService";
import { downloadCsvFile } from "@/shared/fileDownload";
import _ from "lodash";
import {
    FetchState,
} from "@/shared/types";
import {
    AdminSftpTestFilesList,
    SftpTestFile,
    SftpTestFilesState
} from "../types";
import { defineStore } from "pinia";

const defaultState: SftpTestFilesState = {
    canDownload: false,
    fetchState: FetchState.Uninitialized,
    testFiles: []
};

export const useSftpTestFilesStore = defineStore("sftpTestFiles", {
    state: (): SftpTestFilesState => (_.cloneDeep(defaultState)),
    getters: {
        loaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (newFetchState: FetchState) {
            this.fetchState = newFetchState;
        },
        setTestFiles (response: AdminSftpTestFilesList) {
            this.canDownload = response.canDownload;
            this.testFiles = response.testFiles;
            this.fetchState = FetchState.Loaded;
        },
        download (file: SftpTestFile) {
            if (this.fetchState === FetchState.Loading) {
                return;
            }

            return adminSftpTestFileDownload(file).then(response => {
                downloadCsvFile(response.data, _.last(file.s3Key.split("/")));
            });
        },
        load () {
            if (this.fetchState === FetchState.Loading) {
                return;
            }

            this.setFetchState(FetchState.Loading);
            return adminSftpTestFiles().then(response => {
                this.setTestFiles(response.data);
            }).finally(() => this.setFetchState(FetchState.Loaded));
        }
    }
});